import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../utils/styleUtils';

import './LoadingIndicator.scss';


function LoadingIndicator({isLarge, isViewport}) {

    const className = styleUtils.toClasses(
        'loading-indicator',
        isViewport && 'viewport' || null,
        isLarge && 'large' || null
    );

    return (
        <div className={className}>
            <div className={'loader'}>&nbsp;</div>
        </div>
    );
}

LoadingIndicator.propTypes = {
    isLarge: PropTypes.bool,
    isViewport: PropTypes.bool
};

LoadingIndicator.defaultProps = {
    isLarge: false,
    isViewport: false
};

export default LoadingIndicator;
